import React, { PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DatasetActions } from 'Redux/thunks/datasets.thunks';
import { DatahubActions } from 'Redux/thunks/datahub.thunks';

import { useLoadInternalDatasets } from 'src/hooks/useLoadInternalDatasets.hook';

import { EntitiesTabs } from './EntitiesTabs.container';

import Page from '../components/page';
import PageHeader, { PageHeaderGroup, PageHeaderTitle } from '../components/page-header';
import { EntitiesRefreshButton } from '../components/entities-refresh-button/EntitiesRefreshButton.view';

import type { RootState } from '../types/state.types';
import type { ShouldRenderRefreshButton } from '../types/common.types';

export const DatahubSettings: React.FC<
  PropsWithChildren<{
    includeInternal?: boolean;
    shouldRenderRefreshButton?: ShouldRenderRefreshButton;
  }>
> = ({ includeInternal, shouldRenderRefreshButton = 'not-render', children }) => {
  const dispatch = useDispatch();

  const subId = useSelector((state: RootState) => state.subscription.id);
  const token = useSelector((state: RootState) => state.subscription.token);

  const refreshDatahubInfo = () => dispatch(DatahubActions.getInfo());

  const { loadInternalDatasets } = useLoadInternalDatasets(token);

  const loadAll = () => {
    if (includeInternal) {
      loadInternalDatasets();
    } else {
      dispatch(DatasetActions.loadAllForced());
    }
  };

  useEffect(() => {
    refreshDatahubInfo();
  }, []);

  return (
    <Page>
      <PageHeader>
        <PageHeaderTitle>Datahub settings</PageHeaderTitle>
        <PageHeaderGroup>
          <EntitiesRefreshButton
            onClick={() => loadAll()}
            shouldRenderRefreshButton={shouldRenderRefreshButton}
          />
        </PageHeaderGroup>
      </PageHeader>
      <EntitiesTabs subId={subId} entityType="datasets">
        {children}
      </EntitiesTabs>
    </Page>
  );
};
